import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatHoldNotes } from "@redotech/redo-fulfillment-operations-common/hold-notes-formatter";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { memo } from "react";

export const HoldNotesCell = memo(function HoldNotesCell({
  row,
}: {
  row: FulfillmentGroupData;
}) {
  return <RedoTableTextCell text={formatHoldNotes(row.holds)} />;
});
